import { render } from "./card.vue?vue&type=template&id=7971828a&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=7971828a&lang=scss"
import "./card.vue?vue&type=style&index=1&id=7971828a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7971828a"]])

export default __exports__